import { supabase } from '@/lib/supabase/client'

const STORAGE_OBJECT_URL = /\/storage\/v1\/object\/(?:sign|public|authenticated)\/([^/]+)\/([^?#]+)/

/**
 * Profile signatures are stored as signed storage URLs, and those tokens
 * expire. Re-sign from the storage path on every use so expired links still load.
 */
export async function resolveSignatureUrl(url: string): Promise<string> {
  const match = url.match(STORAGE_OBJECT_URL)
  if (!match) return url

  const [, bucket, path] = match
  const { data } = await supabase.storage
    .from(bucket)
    .createSignedUrl(decodeURIComponent(path), 300)

  return data?.signedUrl || url
}
